import React, { useState } from "react";
import { useAppSelector } from "../../hooks/hooks";
import { ChatCliente } from "../../pages/dashboardClientes/chat/ChatCliente";
import { ModalChatInvitado } from "./ModalChatInvitado";
import iconoMensaje from "../../img/editar_landing/Recurso-8.webp";

export const ModalChat = ({ bg }: { bg: string }) => {
    const [abrirChat, setAbrirChat] = useState(false);
    const { id: id_usuario, tipo_usuario } = useAppSelector(
        (state) => state.usuario_logeado,
    );
    const casa = useAppSelector((state) => state.landing_house);
    console.log(
        "estoy en modal chat",
        tipo_usuario,
        casa.house?.plan,
        casa.house.tipo_usuario,
    );
    return (
        <div
            className={
                tipo_usuario === 3 ||
                tipo_usuario === 4 ||
                tipo_usuario === 8 ||
                tipo_usuario === 6 ||
                casa.house?.plan === 1
                    ? "hidden"
                    : "fixed z-20 right-2 bottom-0 sm:right-5"
            }
        >
            <div>
                {abrirChat && id_usuario ? (
                    <div className=" w-96 ">
                        {
                            <ChatCliente
                                landing={abrirChat}
                                setLanding={setAbrirChat}
                            />
                        }
                    </div>
                ) : abrirChat && !id_usuario ? (
                    <ModalChatInvitado
                        setAbrirChat={setAbrirChat}
                        abrirChat={abrirChat}
                    />
                ) : (
                    <div
                        onClick={() => setAbrirChat(true)}
                        className={`flex items-center justify-center w-20 h-20  rounded-full cursor-pointer animate-bounce`}
                    >
                        <img
                            src={iconoMensaje}
                            className="object-cover w-full h-full "
                            alt={`modal chat`}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};
